'use strict';

/**
 * DatasetPreviewController - contrôleur pour la prévisualisation d'un jeu de données
 */
import appModule from '../../app.module';

angular.module(appModule)
.controller('DatasetPreviewController', ['$scope', '$uibModalInstance', 'dataset', '$uibModal', function($scope, $uibModalInstance, dataset, $uibModal) {
  
  // Données du jeu de données
  $scope.dataset = dataset;
  
  // Fermer la modale
  $scope.close = function() {
    $uibModalInstance.dismiss('close');
  };
  
  // Éditer le jeu de données
  $scope.editDataset = function() {
    $uibModalInstance.dismiss('close');
    
    // Ouvrir la modale d'édition
    var modalInstance = $uibModal.open({
      templateUrl: 'app/admin/datasets/dataset-form.html',
      controller: 'DatasetFormController',
      resolve: {
        dataset: function() {
          return angular.copy($scope.dataset);
        }
      }
    });
    
    // Mettre à jour la liste si nécessaire après l'édition
    modalInstance.result.then(function(updatedDataset) {
      // La mise à jour sera gérée par le contrôleur parent (AdminDatasetsController)
    });
  };
}]);
